/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_All_CreditsInputs */

const en_admin_credits_all_credits = /** @type {(inputs: Admin_Credits_All_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Credits`)
};

const zh_admin_credits_all_credits = /** @type {(inputs: Admin_Credits_All_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有积分`)
};

/**
* | output |
* | --- |
* | "All Credits" |
*
* @param {Admin_Credits_All_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_all_credits = /** @type {((inputs?: Admin_Credits_All_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_All_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_all_credits(inputs)
	return zh_admin_credits_all_credits(inputs)
});
export { admin_credits_all_credits as "admin.credits.all_credits" }